const items: { q: string; a: React.ReactNode }[] = [
  {
    q: "Voor welke leeftijd zijn de workshops?",
    a: "Kinderworkshops zijn voor 10-12 jaar (5de-6de leerjaar), geen voorkennis nodig. De Makers Hub community (open werkplaats, fase 2) is voor volwassenen vanaf 18 jaar.",
  },
    {
    q: "Wat houdt de 'pilot' precies in?",
    a: "Makers Hub is net van start. We draaien nu onze eerste workshops om het concept uit te testen en te kijken welke gezinnen interesse hebben. De feedback van deze eerste deelnemers bepaalt hoe we verder groeien — welke projecten, welke zaterdagen, welke formules. Je bent als eerste mee vanaf dag één.",
  },
  {
    q: "Moet mijn kind al kunnen programmeren?",
    a: "Nee. We beginnen bij de absolute basis — eerste LED laten branden — en bouwen stap voor stap op. Kinderen met ervaring krijgen extra uitdaging binnen het project.",
  },
  {
    q: "Moet mijn kind een laptop meebrengen?",
    a: "Ja, een eigen laptop (Windows, Mac of Linux) is vereist. Arduino IDE wordt ter plaatse geïnstalleerd (gratis software). Geen laptop thuis? Contacteer ons — we hebben een beperkt aantal reserve-laptops.",
  },
  {
    q: "Wat als we niet kunnen op de gereserveerde dag?",
    a: (
      <>
        <p>
          Tot 7 dagen ervoor: volledige terugbetaling. Tussen 2-7 dagen: 50%. Binnen 48u:
          overdraagbaar naar een volgende sessie.
        </p>
        <p>
          Als Makers Hub zelf annuleert (bv. te weinig inschrijvingen, minder dan 4): volledige
          terugbetaling.
        </p>
      </>
    ),
  },
  {
    q: "Wat zit er bij de pilot-prijs van €30?",
    a: "Alles. Drie uur workshop, alle elektronica-componenten (Arduino, breadboard, LEDs, knoppen, buzzer), begeleiding en een werkend Simon Says-apparaat om mee naar huis te nemen. Je hoeft enkel een laptop mee te brengen. Pauze met drankje inbegrepen. €30 is onze introprijs voor de eerste edities (normaal €50).",
  },
  {
    q: "Kan de kit hergebruikt worden voor volgende workshops?",
    a: "Ja — de Elegoo Basic Starter Kit (t.w.v. €20) blijft van je kind en is herbruikbaar in elke volgende workshop. Volgende workshops kosten dan slechts €10 (zonder nieuwe kit) — je betaalt enkel begeleiding, ruimte en eventuele extra modules.",
  },
  {
    q: "Waar vinden de workshops plaats?",
    a: "In een gehuurd klaslokaal in een school in de regio. Exacte locatie ontvang je bij bevestiging van je inschrijving. Goed bereikbaar, voldoende parking.",
  },
  {
    q: "Zijn jullie verzekerd?",
    a: "Ja — vzw met BA-verzekering (burgerlijke aansprakelijkheid) en een verzekering lichamelijke ongevallen voor deelnemers. We werken met laagspanning (5V Arduino) en geen soldeerbout voor beginners.",
  },
];

export function FAQ() {
  return (
    <section className="bg-alt" id="faq">
      <div className="container">
        <div className="section-head">
          <span className="section-tag">Veelgestelde vragen</span>
          <h2>Wat je moet weten voor je meedoet</h2>
          <p>
            We zijn net gestart en draaien onze eerste workshops als test. Hieronder de meest
            gestelde vragen — iets niet terug te vinden? Stuur gerust een mail naar hallo.contact@makershub.be.
          </p>
        </div>
        <div className="faq-list">
          {items.map((item, i) => (
            <details className="faq-item" key={i}>
              <summary>{item.q}</summary>
              <div className="faq-body">
                {typeof item.a === "string" ? <p>{item.a}</p> : item.a}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
